<script setup>
import BackgroundSection from './BackgroundSection.vue'
import content from '../content.js'

const team = content.team
</script>

<template>
  <BackgroundSection
    section-id="team"
    :video="team.video"
    :image="team.image"
    overlay-class="bg-black/50"
  >
    <div class="max-w-6xl mx-auto px-6 text-center">
      <h2 class="text-3xl sm:text-4xl md:text-5xl font-bold mb-12 mt-16 text-shadow" data-aos="fade-up">
        {{ team.title }}
      </h2>
      <div class="grid sm:grid-cols-2 md:grid-cols-3 gap-8 mb-12">
        <div v-for="(member, i) in team.members" :key="i"
             class="space-y-4"
             data-aos="zoom-in"
             :data-aos-delay="i * 100">
          <img :src="member.image" :alt="member.name"
               class="w-40 h-40 rounded-full mx-auto object-cover shadow-lg border-4 border-white" />
          <h3 class="text-xl font-semibold">{{ member.name }}</h3>
          <p class="text-gray-300">{{ member.role }}</p>
        </div>
      </div>
    </div>
  </BackgroundSection>
</template>
